/* eslint-disable arrow-body-style */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import useFilms from '../../hooks/useFilms';

import FilmCard from '../cards/Film';
import Description from '../partials/Description';
import Image from '../partials/Image';
import PageMeta from '../partials/PageMeta';
import Title from '../typography/Title';

import styles from '../../../styles/pages/person.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function PersonPage({ page = null }) {
    const {
        name = null,
        title = null,
        employer = null,
        bio = null,
        image = null,
        query = null,
    } = page || {};

    const { data: films = null } = useFilms({ query });

    const titleText = useMemo(() => {
        if (title !== null && employer !== null) {
            return `${title}, ${employer}`;
        }
        if (title !== null) {
            return title;
        }
        if (employer !== null) {
            return employer;
        }
        return null;
    }, [title, employer]);

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <div className={styles.header}>
                {image !== null ? (
                    <Image
                        className={styles.image}
                        image={image}
                        size="large"
                        filtered
                        rounded
                        square
                    />
                ) : null}
                <div className={classNames([styles.top, { [styles.noImage]: image === null }])}>
                    <Title className={styles.name} size="large">
                        {name}
                    </Title>
                    {titleText !== null ? (
                        <Title className={styles.title}>{titleText}</Title>
                    ) : null}
                    <Description className={styles.bio} body={bio} />
                </div>
            </div>
            {films !== null && films.length > 0 ? (
                <>
                    <Title className={styles.subtitle}>
                        <FormattedMessage
                            defaultMessage="Related films"
                            description="Section title"
                        />
                    </Title>
                    <div className={styles.films}>
                        {films.map((film) => {
                            return (
                                <FilmCard
                                    item={film}
                                    key={`film-${film?.id}`}
                                    className={styles.film}
                                />
                            );
                        })}
                    </div>
                </>
            ) : null}
        </div>
    );
}

PersonPage.propTypes = propTypes;

export default PersonPage;
